<div class="material-page">
  <div class="mdc-layout-grid" *ngIf="integrationId !== undefined">
    <div class="mdc-layout-grid__inner">
    
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 class="mat-headline-3" i18n>My items</h1>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
        <mat-card style="margin: 0px; background-color: #D6E9D5; text-align: center">
          <mat-card-header style="justify-content: center;">
            <mat-card-title class="mat-subtitle-2" i18n>Total items</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <h1 class="mat-headline-6"><b>{{itemPicker.loading ? '&nbsp;' : itemPicker.items.length}}</b></h1>
          </mat-card-content>
        </mat-card>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
        <mat-card style="margin: 0px; background-color: #D6E9D5; text-align: center">
          <mat-card-header style="justify-content: center;">
            <mat-card-title class="mat-subtitle-2" i18n>Total price</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <h1 class="mat-headline-6"><b>{{(itemPicker.loading || !totalPrice) ? '&nbsp;' : (totalPrice.toNumber() | currency : 'EUR':'symbol':'1.0-2')}}</b></h1>
          </mat-card-content>
        </mat-card>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">  
      
        <item-picker #itemPicker (onListRefreshed)="onItemListRefreshed()" [hasGMailIntegration]="!!integrationId"></item-picker>
        
        <div *ngIf="integrationId && itemPicker && !itemPicker.loading && itemPicker.items.length === 0">
          <p i18n>Oops, it seems that our AI is not yet smart enough to find your purchases. We will train it harder. Please try again in a short while.</p>
        </div>
        
        <div *ngIf="integrationId && !itemPicker.loading">
          <div style="margin-top: 32px;">
            <scan-gmail-button (onScanned)="itemPicker.reload()"></scan-gmail-button>
          </div>
        </div>

        <div *ngIf="integrationId && itemPicker && itemPicker.items.length > 0">
          <p class="mat-caption" style="margin-top: 32px" i18n>
            We know some items might be missing and some may look a bit weird. Our AI is getting smarter each day, so make sure to come back in a few weeks.
          </p>
        </div>
        
      </div>
    </div>
  </div>
</div>